export default "__VITE_ASSET__COW$IgFd__"